import { defineMessages } from 'react-intl';

export default defineMessages({
  pending : {
    id: 'inventorystatus.pending.title',
    defaultMessage: 'Pending'
  },
  pick : {
    id: 'inventorystatus.pick.title',
    defaultMessage: 'Pick'
  },
  pack : {
    id: 'inventorystatus.pack.title',
    defaultMessage: 'Pack'
  },
  ship : {
    id: 'inventorystatus.ship.title',
    defaultMessage: 'Ship'
  },
  received : {
    id: 'inventorystatus.received.title',
    defaultMessage: 'Received'
  }
});
